import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { Text } from '@fluentui/react/lib/Text';
import { TextField } from '@fluentui/react/lib/TextField';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Checkbox } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../system/TimeTaxSupportSystemClient';
import { User } from '../system/User';
import { MessageReceiver } from '../lib/MessageReceiver';
import MessageCourier from '../lib/MessageCourier';
import { APP_NAME, LOGO_PATH, routes } from '../common/constants';
import { t } from 'i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { TOTPDialog } from './TOTPDialog';
import { IQRurl } from '../system/AuthenticationSystem';
import { saveOnSessionStorageDataTable } from '../lib/GlideDataGrid/UtilsGlideGrid';

interface ILoginViewProps {
  system: TimeTaxSupportSystemClient;
  tokenGetter: () => Promise<string>;
  onLogin: (user: User) => void;
  changeBlockUI: (change: boolean) => void;
  errorCodeRetrieved: any;
}

interface ILoginViewState {
  user: User | undefined;
  email: string | null;
  password: string | null;
  showLoginForm: boolean;
  showTOTPDialog: boolean;
  showTOTPDialogError: boolean;
  hasBeenVinculated: boolean;
  qrValue: string;
  formErrors: { [index: string]: any; email: string; password: string };
  errorMessage: string;
  emailValid: boolean;
  passwordValid: boolean;
  formValid: boolean;
  [index: string]: any;
}

const errorTextStyles = {
  root: {
    textAlign: 'center',
    marginBottom: '10px',
    color: 'red',
  },
};
class LoginView extends React.Component<ILoginViewProps, ILoginViewState> implements MessageReceiver {
  private courier: MessageCourier;
  constructor(props: ILoginViewProps) {
    super(props);
    this.state = {
      user: undefined,
      qrValue: '',
      email: '',
      password: '',
      formErrors: { email: '', password: '' },
      hasBeenVinculated: true,
      showLoginForm: false,
      showTOTPDialog: false,
      showTOTPDialogError: false,
      emailValid: false,
      passwordValid: false,
      formValid: false,
      errorMessage: '',
      checked: false,
      isWriting: false,
    };

    this.courier = new MessageCourier();
  }

  componentDidMount(): void {
    if (localStorage.getItem('email') !== '' && localStorage.getItem('email') !== null) {
      this.setState({
        email: localStorage.getItem('email') != null ? localStorage.getItem('email') : '',
        password: '',
        checked: true,
      });
      this.validateForm();
    }

    this.courier.subscribe(this);
  }

  receiveError(message: string, _error: unknown): void {
    this.setState({ errorMessage: message });
  }
  receiveSuccess(message: string): void {
    throw new Error('Method not implemented.');
  }

  passwordIsValid(): boolean {
    return !!this.state.password && this.state.password.length >= 6;
  }

  emailIsValid() {
    if (this.state.email) return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email);
    else return false;

    // return (this.state.email && this.state.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/))
  }

  showForm = () => {
    this.setState({ showLoginForm: true });

    if (localStorage.getItem('email') !== '' && localStorage.getItem('email') !== null) {
      let fieldValidationErrors = this.state.formErrors;
      // let emailValid = this.state.emailValid;
      // let passwordValid = this.state.passwordValid;

      let emailValid = this.emailIsValid();
      fieldValidationErrors.email = emailValid || this.state.isWriting ? '' : t('Email es inválido');

      let passwordValid = this.passwordIsValid();
      fieldValidationErrors.password =
          passwordValid || this.state.isWriting ? '' : t('Contraseña es demasiado corta');

      this.setState(
          {
            formErrors: fieldValidationErrors,
            emailValid: emailValid,
            passwordValid: passwordValid,
          },
          this.validateForm
      );
    }
  };

  changeShowForm = (stateShow: boolean) => {
    this.setState({
      user: undefined,
      qrValue: '',
      email: '',
      password: '',
      formErrors: { email: '', password: '' },
      hasBeenVinculated: true,
      showLoginForm: stateShow,
      showTOTPDialog: false,
      showTOTPDialogError: false,
      emailValid: false,
      passwordValid: false,
      formValid: false,
      errorMessage: '',
      checked: false,
      isWriting: false,
    });
  }

  validateField = (e: any) => {
    const fieldName = e.target.name;
    const value = e.target.value;
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let passwordValid = this.state.passwordValid;

    switch (fieldName) {
      case 'email':
        emailValid = value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        fieldValidationErrors.email = emailValid ? '' : t('Email es inválido');
        break;
      case 'password':
        passwordValid = value.length >= 6;
        fieldValidationErrors.password = passwordValid ? '' : t('Contraseña es demasiado corta');
        break;
      default:
        break;
    }
    this.setState(
        {
          formErrors: fieldValidationErrors,
          emailValid: emailValid,
          passwordValid: passwordValid,
        },
        this.validateForm
    );
  };

  validateForm() {
    this.setState({ formValid: this.state.emailValid && this.state.passwordValid });
  }

  handleUserInput = (e: any) => {
    this.setState({ errorMessage: '' });
    const name = e.target.name;
    const value = e.target.value;
    let _state = { ...this.state };
    _state[name] = value;
    this.setState({ [name]: value });
  };

  showErrors = (validationField: string) => {
    if (!this.state.isWriting) {
      return (
          <div className="formErrors">
            {Object.keys(this.state.formErrors).map((fieldName, i) => {
              if (fieldName === validationField) {
                if (this.state.formErrors[fieldName].length > 0 && !this.state.isWriting) {
                  return (
                      <Text
                          variant="mediumPlus"
                          nowrap
                          block
                          key={i}
                          style={{
                            textAlign: 'center',
                            marginBottom: '10px',
                            color: 'red',
                          }}
                      >
                        {fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}{' '}
                        {this.state.formErrors[fieldName]}
                      </Text>
                  );
                } else {
                  return '';
                }
              }
            })}
          </div>
      );
    }
  };

  rememberMe = () => {
    localStorage.setItem('email', this.state.checked && this.state.email ? this.state.email : '');
  };

  onChangeCheckbox = () => {
    this.setState({ checked: !this.state.checked });
  };

  getMsgByCodeRetrieved = () => {
    switch (+this.props.errorCodeRetrieved) {
      case 601:
        return t('Credenciales invalidas **');
    }
  };

  render() {
    const { errorMessage } = this.state;

    return (
      <form
        className="form-back"
        onSubmit={(e) => {
          e.preventDefault();
          this.rememberMe();
          this.onSubmit();
          // saveOnSessionStorageDataTable([]);
        }}
      >
        <div
          className="ms-Grid page-body "
          style={{ padding: "0px 20px" }}
          dir="ltr"
        >
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-xl3 ms-lg6 ms-sm12"
              style={{ margin: "0 auto", textAlign: "center", float: "none" }}
            >
              <div
                className="login-container panel"
                style={{
                  width: "320px",
                  height: "100%",
                  marginRight: "auto",
                  marginLeft: "auto",
                  minHeight: "320px",
                  display: "block",
                }}
              >
                <div
                  className="panel-heading"
                  style={{ width: "100%", padding: "20px 0" }}
                >
                  <img src={LOGO_PATH} alt="logo" className="tts-logo"></img>
                </div>
                <div
                  style={{
                    width: "70%",
                    margin: "auto",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >  
                   {!this.state.showLoginForm ? (
                    <>
                      <TextField
                        // styles={inputFieldStyles}
                        placeholder={t("Email")}
                        className="login-input-field fadeIn"
                        value={this.state.email ? this.state.email : ""}
                        onChange={(e) => {
                          this.handleUserInput(e);
                          this.validateField(e);
                          this.setState({ isWriting: true });
                        }}
                        onBlur={(e) => {
                          // this.handleUserInput(e);
                          this.validateField(e);
                          this.setState({ isWriting: false });
                        }}
                        name="email"
                        errorMessage={
                          !this.state.isWriting ? this.state.formErrors.email : ""
                        }
                        // iconProps={mailIcon}
                      />
                      <PrimaryButton
                        text={t("Siguiente")}
                        type="submit"
                        allowDisabledFocus
                        className="login-button fadeIn"
                      />
                      <PrimaryButton
                        text={t("Opciones de inicio de sesión")}
                        allowDisabledFocus
                        className="login-button fadeIn"
                        style={{
                          borderColor: "#909fa72f",
                          color: "black",
                          backgroundColor: "#f5f3f3",
                        }}
                        onClick={() => this.changeShowForm(true)}
                      />
                    </>
                   ) : (
                    <div
                      style={{ marginTop: "10px" }}
                      className='fadeIn'
                    >
                      <TextField
                        // styles={inputFieldStyles}
                        placeholder={t("Email")}
                        className="login-input-field"
                        value={this.state.email ? this.state.email : ""}
                        onChange={(e) => {
                          this.handleUserInput(e);
                          this.validateField(e);
                          this.setState({ isWriting: true });
                        }}
                        onBlur={(e) => {
                          // this.handleUserInput(e);
                          this.validateField(e);
                          this.setState({ isWriting: false });
                        }}
                        name="email"
                        errorMessage={
                          !this.state.isWriting ? this.state.formErrors.email : ""
                        }
                        // iconProps={mailIcon}
                      />
                      {/* {this.showErrors('email')} */}
                      <TextField
                        // styles={inputFieldStyles}
                        placeholder={t("Contraseña")}
                        className="login-input-field"
                        value={this.state.password ? this.state.password : ""}
                        name="password"
                        canRevealPassword
                        revealPasswordAriaLabel="Mostrar contraseña"
                        onChange={(e) => {
                          this.handleUserInput(e);
                          this.validateField(e);
                          this.setState({ isWriting: true });
                        }}
                        onBlur={(e) => {
                          // this.handleUserInput(e);
                          this.validateField(e);
                          this.setState({ isWriting: false });
                        }}
                        type="password"
                        errorMessage={
                          !this.state.isWriting
                            ? this.state.formErrors.password
                            : ""
                        }
                        // iconProps={lockIcon}
                      />
                      {/* {this.showErrors('password')} */}
                      <div style={{ display: "block", float: "left" }}>
                        <Checkbox
                          label={t("Recordarme")}
                          className="remember-user-checkbox"
                          checked={this.state.checked}
                          onChange={this.onChangeCheckbox}
                        />
                      </div>
                      <PrimaryButton
                        className="iniciar-sesion-btn"
                        text={t("Iniciar Sesión")}
                        allowDisabledFocus
                        disabled={!this.state.formValid}
                        type="submit"
                      />
                      <Link
                        to={routes.recover_password}
                        className="forgot-password mt-2"
                      >
                        {t("Olvidaste tu contraseña?")}
                      </Link>
                      <div
                        style={{
                          display: "block",
                          textAlign: "center",
                          marginBottom: "10px",
                          marginTop:"25px",
                          cursor: "pointer"
                        }}
                        onClick={() => this.changeShowForm(false)}
                      >
                        <span style={{ textDecoration: "underline" }}>
                          {t("Volver")}
                        </span>
                      </div>
                    </div>
                   )}
                 
                  <Text
                      variant="mediumPlus"
                      nowrap
                      block
                      styles={errorTextStyles}
                    >
                      {t(errorMessage)}
                  </Text>
                  {this.props.errorCodeRetrieved && (
                    <Text
                      variant="mediumPlus"
                      nowrap
                      block
                      className="mt-1 error-color"
                    >
                      {this.getMsgByCodeRetrieved()}
                    </Text>
                  )}
                </div>
                <div
                  className="panel-footer"
                  style={{
                    width: "320px",
                    marginRight: "auto",
                    marginLeft: "auto",
                    display: "block",
                  }}
                >
                  <Text
                    variant="medium"
                    nowrap
                    block
                    style={{
                      textAlign: "center",
                    }}
                  >
                    © {new Date().getFullYear()} - {APP_NAME}
                  </Text>

                  <a
                    href={routes.politica_de_privacidad}
                    className='politicas-de-privacidad'
                    target='_blank'
                    rel="noreferrer"
                  >Política de Privacidad</a>

                  <a
                    href={routes.terminos_y_condiciones}
                    className='politicas-de-privacidad'
                    target='_blank'
                    rel="noreferrer"
                  >términos y condiciones</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TOTPDialog
          show={this.state.showTOTPDialog}
          hasBeenVinculated={this.state.hasBeenVinculated}
          onAccept={(code) => this.onSendTOTPCode(code)}
          onCancel={() => this.onCancelTOTPDialog()}
          showTOTPDialogErrorCode={this.state.showTOTPDialogErrorCode}
          QRValue={this.state.qrValue}
        ></TOTPDialog>
      </form>
    );
  }

  private async onSendTOTPCode(code: string) {
    this.props.changeBlockUI(true);
    try {
      const user = await this.props.system.getAuthenticationSystem().validateCode2FA(code);
      this.props.onLogin(user);
      this.setState({ showTOTPDialog: false });
    } catch (e) {
      console.log(e);
      this.setState({ showTOTPDialogErrorCode: true });
    }
    this.props.changeBlockUI(false);
  }

  private onCancelTOTPDialog() {
    this.setState({ showTOTPDialog: false });
  }

  private async onSubmit() {
    this.props.changeBlockUI(true);

    try {
      const { email, password } = this.state;

      if (!email) return;

      if (password && email && this.state.showLoginForm) {
        const token = await this.props.tokenGetter();
        const statusResponse = await this.props.system.checkEmail(email, token);
        if (!statusResponse.isOk()) return;
        this.onLoginWithCredential(email, password);
      } else if(email && !this.state.showLoginForm){
        const token = await this.props.tokenGetter();
        const statusResponse = await this.props.system.checkEmail(email, token);
        if (!statusResponse.isOk()) return;
        this.onCorporateSignInClicked();
      }
    } catch (e) {
      this.courier.messageError(e);
      this.setState({ password: '' });
    } finally {
      this.props.changeBlockUI(false);
    }
  }

  private onCorporateSignInClicked = () => {
    return this.props.system.corporateSignIn();
  };

  private onLoginWithCredential = async (email: string, password: string) => {
    const token = await this.props.tokenGetter();
    const statusResponse  = await this.props.system.signIn(email, password, token) as any ;
    let error = 'Error deconosido';

    if(!statusResponse.isOk()){
        error =statusResponse.message.originalError.response.data.error;
        this.setState({ isWriting: false });
        this.setState({errorMessage: error})
      }

    if (statusResponse.isOk()) {
      const user = statusResponse.getData() as User;
      this.props.onLogin(user);
      this.setState({ user: user });
    }

    if (statusResponse.shouldShowQRAuth()) {
      const qr = statusResponse.getData() as IQRurl;
      this.setState({ showTOTPDialog: true });
      this.setState({ qrValue: qr.qrUrl });
      this.setState({ hasBeenVinculated: false });
    }

    if (statusResponse.requireTOTPCode()) {
      this.setState({ showTOTPDialog: true });
    }
  }
}

interface ILoginViewWrapperProps {
  system: TimeTaxSupportSystemClient;
  tokenAction: string;
  onLogin: (user: User) => void;
  changeBlockUI: (change: boolean) => void;
}

const LoginViewWrapper = (props: ILoginViewWrapperProps) => {
  const captcha = useGoogleReCaptcha();
  const getToken = async () => {
    return captcha.executeRecaptcha ? await captcha.executeRecaptcha(props.tokenAction) : '';
  };

  const [searchParams] = useSearchParams();
  const errorCodeRetrieved = searchParams.get('error');

  return (
      <LoginView
          errorCodeRetrieved={errorCodeRetrieved}
          system={props.system}
          tokenGetter={getToken}
          onLogin={props.onLogin}
          changeBlockUI={props.changeBlockUI}
      />
  );
};

export default LoginViewWrapper;
